
export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://static.readdy.ai/image/fab5168e291508d3586d4b84ed71e8b7/96c3e3497bafabc28fcf70a7da3df85a.png)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B1F3B]/80 via-[#0B1F3B]/75 to-[#0B1F3B]/80"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32 lg:py-40 text-center">
        <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 sm:mb-8 leading-tight">
          Valutazione e Valorizzazione
          <br />
          del Brand come Asset Patrimoniale Aziendale
        </h1>
        <p className="text-lg sm:text-xl lg:text-2xl text-white/90 mb-12 sm:mb-16 lg:mb-24 max-w-4xl mx-auto font-light leading-relaxed px-4">
          Trasformiamo il valore nascosto della tua azienda in opportunità concrete di crescita e sviluppo strategico
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 px-4">
          <a
            href="#contatti"
            className="w-full sm:w-auto px-8 sm:px-10 py-3.5 sm:py-4 bg-[#E879F9] text-white rounded-md text-base sm:text-lg font-semibold hover:bg-[#E879F9]/90 transition-all whitespace-nowrap cursor-pointer"
          >
            Richiedi Valutazione Gratuita
          </a>
          <a
            href="#metodo"
            className="w-full sm:w-auto px-8 sm:px-10 py-3.5 sm:py-4 bg-[#22C55E] text-white rounded-md text-base sm:text-lg font-semibold hover:bg-[#22C55E]/90 transition-all whitespace-nowrap cursor-pointer"
          >
            Scopri il Metodo BCI
          </a>
        </div>
      </div>
    </section>
  );
}
